
































































































import { Component, Prop } from 'vue-property-decorator';
import Mixin from '@/mixin';
import { validationMixin } from 'vuelidate';
import messageModule from '@/store/modules/common/message.module';
import VMessage from '@/components/items/VMessage.vue';
import VPasswordInput from '@/components/items/VPasswordInput.vue';
import { minLength, required, sameAs } from 'vuelidate/lib/validators';
import coachService from '@/services/common/coach.service';
import managerService from '@/services/common/manager.service';

@Component({
  name: 'VPopupResetPassword',
  components: { VPasswordInput, VMessage },
  mixins: [validationMixin],
  validations: {
    password: { required, minLength: minLength(6) },
    passwordConfirmation: { required, samAsPassword: sameAs('password') }
  }
})
export default class VPopupResetPassword extends Mixin {
  @Prop({ required: false }) id?: number;
  @Prop({ required: false }) title?: string;
  @Prop({ required: false }) type?: 'manager' | 'coach';
  @Prop({ required: true }) isShowModal?: boolean;

  public password = '';
  public passwordConfirmation = '';

  get message() {
    return messageModule.message;
  }

  get messageType() {
    return messageModule.type;
  }

  get allowSubmit() {
    return !(this.$v?.$error || this.$v?.$invalid);
  }

  public async save() {
    this.$v?.$touch();
    if (this.allowSubmit && this.id) {
      if (this.type === 'coach') {
        await coachService.resetPassword(this.id, { password: this.password });
      } else if (this.type == 'manager') {
        await managerService.resetPassword(this.id, {
          password: this.password
        });
      }
      this.$emit('hide');
    }
  }
}
